import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import {FormattedMessage} from "react-intl";

export const ErrorView = (props) => {
    return (
        <Column spacingInset="large">
            <Row>
                <Heading level={1}><FormattedMessage id="search.error" defaultMessage="Go Slow!!! Report can be generated for 1 days at a time" /> </Heading>
            </Row>
        </Column>
    );
}


// WEBPACK FOOTER //
// ./src/components/detailPages/associateDetails/safetyReport/ErrorView.js